import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'
import { depositInvoiceEditorVariants } from './depositInvoiceEditorVariants'

export const depositOrFinalInvoiceEditorVariants = [
  ...depositInvoiceEditorVariants,
  InvoiceEditorVariant.FinalInvoiceDraftEdit,
  InvoiceEditorVariant.FinalInvoiceNewFromQuote,
]
